import React from "react"

import globalStyles from "../../../../App.module.scss";
import inputListing from './images/input.png'
import output from './images/output.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function DuplicateFileFinder() {

    let data = `import argparse
import hashlib
from collections import defaultdict
from pathlib import Path


def hash_file(path, chunk_size=65536):
    hasher = hashlib.sha256()
    with open(path, "rb") as f:
        for chunk in iter(lambda: f.read(chunk_size), b""):
            hasher.update(chunk)
    return hasher.hexdigest()


def find_duplicates(root):
    # Group by size first; only hash files that share a size with at
    # least one other file, since a unique size can never collide.
    by_size = defaultdict(list)
    for path in Path(root).rglob("*"):
        if path.is_file():
            by_size[path.stat().st_size].append(path)

    duplicates = defaultdict(list)
    for candidates in by_size.values():
        if len(candidates) < 2:
            continue
        for path in candidates:
            duplicates[hash_file(path)].append(path)

    return {digest: paths for digest, paths in duplicates.items() if len(paths) > 1}


def main():
    parser = argparse.ArgumentParser(description="Find duplicate files in a directory tree")
    parser.add_argument("directory")
    args = parser.parse_args()

    duplicate_groups = find_duplicates(args.directory)

    if not duplicate_groups:
        print("No duplicates found.")
        return

    wasted_bytes = 0
    for digest, paths in duplicate_groups.items():
        print(f"\\n{digest[:12]}...")
        for path in paths:
            print(f"  {path}")
        wasted_bytes += paths[0].stat().st_size * (len(paths) - 1)

    print(f"\\n{len(duplicate_groups)} duplicate group(s), "
          f"{wasted_bytes / 1024 / 1024:.2f} MB reclaimable.")


if __name__ == "__main__":
    main()
`

    return (
        <div className={globalStyles.article}>
            <h1>Duplicate file finder</h1>
            <p>Walks a directory tree and reports groups of duplicate files. Files are first grouped by size (a
                unique size can never be a duplicate), then only same-sized candidates are hashed with SHA-256 to
                confirm the match — avoiding hashing every file up front on a large tree.</p>
            <div style={{maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'python'}
                />
            </div>
            <p>Input: a folder containing some duplicate files, mixed in among files that only exist once.</p>
            <div style={{maxWidth: '317px'}}>
                <img src={inputListing} alt={""}/>
            </div>

            <p>Output: running the script against that folder reports each duplicate group and the space that
                could be reclaimed by removing the extra copies.</p>
            <div style={{maxWidth: '407px'}}>
                <img src={output} alt={""}/>
            </div>
        </div>
    )
}
